<po-page-default
  p-title="Modulo de Entrada NFs - Download de documentos PDF"
  [p-actions]="pageActions">

  <form [formGroup]="filterForm">
    <div class="po-row">
      <po-select
        class="po-md-3"
        formControlName="tipoSelecionado"
        name="tipoSelecionado"
        p-label="Tipo"
        [p-options]="tipoOptions">
      </po-select>

      <po-select
        class="po-md-3"
        formControlName="somenteNovos"
        name="somenteNovos"
        p-label="Somente arquivos novos"
        [p-options]="somenteNovosOptions">
      </po-select>

      <po-select
        class="po-md-3"
        formControlName="origemSelecionada"
        name="origemSelecionada"
        p-label="Origem"
        [p-options]="origemOptions">
      </po-select>

      <po-input
        class="po-md-3"
        formControlName="email"
        name="email"
        p-label="E-mail (opcional)"
        p-placeholder="Padrao: e-mail do usuario">
      </po-input>
    </div>

    <div class="po-row">
      <po-datepicker
        class="po-md-3"
        formControlName="dataInicial"
        name="dataInicial"
        p-clean
        p-label="Data Inicial">
      </po-datepicker>

      <po-datepicker
        class="po-md-3"
        formControlName="dataFinal"
        name="dataFinal"
        p-clean
        p-label="Data Final">
      </po-datepicker>
    </div>
  </form>

  <po-divider class="divider-destaque" p-label="Últimas Solicitações"></po-divider>

  <po-loading-overlay *ngIf="loadingList" p-text="Carregando..."></po-loading-overlay>
  <po-loading-overlay *ngIf="enviando" p-text="Registrando solicitacao..."></po-loading-overlay>

  <po-table
    [p-columns]="columns"
    [p-items]="solicitacoes"
    [p-sort]="true"
    [p-striped]="true"
    [p-show-more-disabled]="true">
  </po-table>

</po-page-default>
